import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/** Branded "not found" page. Sets noindex so search engines drop the URL, and a
 *  `render:status_code` meta so the prerender build emits a real 404.html the
 *  production host can serve with an HTTP 404 status. */
export default function NotFound() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Page not found · Brotherhood+';
    const added = [];
    const ensure = (name, content) => {
      let el = document.head.querySelector(`meta[name="${name}"][data-nf="1"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute('name', name); el.setAttribute('data-nf', '1'); document.head.appendChild(el); added.push(el); }
      el.setAttribute('content', content);
    };
    ensure('robots', 'noindex, nofollow');
    ensure('render:status_code', '404');
    return () => { document.title = prevTitle; added.forEach((el) => el.remove()); };
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6" data-testid="notfound-page">
      <div className="text-center max-w-md">
        <p className="text-[11px] uppercase tracking-[0.24em] text-gold font-semibold">Error 404</p>
        <h1 className="font-heading text-4xl sm:text-5xl mt-2 leading-tight text-navy">This page isn't here</h1>
        <p className="mt-4 text-navy/70 leading-relaxed">
          The page you're looking for moved or never existed. Let's get you back on track.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center justify-center gap-2 rounded-full bg-navy text-white px-6 py-3 text-sm font-semibold hover:opacity-90 transition-smooth" data-testid="notfound-home">
            <ArrowLeft size={14} aria-hidden="true"/> Back to home
          </Link>
          <Link to="/directory" className="inline-flex items-center justify-center rounded-full border border-navy/20 text-navy px-6 py-3 text-sm font-semibold hover:bg-navy/5 transition-smooth" data-testid="notfound-directory">
            Find a therapist
          </Link>
        </div>
        <p className="mt-6 text-sm text-navy/55 flex flex-wrap justify-center gap-x-4 gap-y-1">
          <Link to="/features" className="underline hover:text-navy">Features</Link>
          <Link to="/about" className="underline hover:text-navy">About</Link>
          <Link to="/faq" className="underline hover:text-navy">FAQ</Link>
        </p>
      </div>
    </div>
  );
}
